import HubAccessTherapyPage from './HubAccessTherapyPage'

export default HubAccessTherapyPage
